// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ArbitrationDocumentDTO } from './arbitration-document-dto';
import { ArbitrationResponseDTO } from './arbitration-response-dto';
import { OrderWithOrderCustomersDTO } from './order-with-order-customers-dto';

/**
 * 
 * @export
 * @interface ArbitrationDTO
 */
export interface ArbitrationDTO {
    /**
     * 
     * @type {string}
     * @memberof ArbitrationDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ArbitrationDTO
     */
    claimId: string;
    /**
     * 
     * @type {string}
     * @memberof ArbitrationDTO
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof ArbitrationDTO
     */
    status: ArbitrationDTOStatusEnum;
    /**
     * 
     * @type {Array<ArbitrationResponseDTO>}
     * @memberof ArbitrationDTO
     */
    responses: Array<ArbitrationResponseDTO>;
    /**
     * 
     * @type {string}
     * @memberof ArbitrationDTO
     */
    message?: string;
    /**
     * 
     * @type {number}
     * @memberof ArbitrationDTO
     */
    arbitratedAmount: number;
    /**
     * 
     * @type {string}
     * @memberof ArbitrationDTO
     */
    repaymentOrderId?: string;
    /**
     * 
     * @type {OrderWithOrderCustomersDTO}
     * @memberof ArbitrationDTO
     */
    repaymentOrder?: OrderWithOrderCustomersDTO;
    /**
     * 
     * @type {string}
     * @memberof ArbitrationDTO
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ArbitrationDTO
     */
    paymentDeadline: string | null;
    /**
     * 
     * @type {Array<ArbitrationDocumentDTO>}
     * @memberof ArbitrationDTO
     */
    documents?: Array<ArbitrationDocumentDTO>;
}

/**
    * @export
    * @enum {string}
    */
export enum ArbitrationDTOStatusEnum {
    DRAFT = 'DRAFT',
    PUBLISHED = 'PUBLISHED'
}



